import {RouteRecordRaw} from "vue-router";

const petChildren: RouteRecordRaw[] = [
  {
    path: 'info',
    name: 'PetDetails',
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'PetInfo',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/details/Details.vue'),
      },
      {
        path: 'credential',
        name: 'PetCredential',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/details/Credential.vue'),
      },
    ],
  },
  {
    path: 'medical-records',
    name: 'PetMedicalRecords',
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'ListMedicalRecords',
        meta: {requiresAuth: true},
        component: () => import('@/features/medical-records/views/MedicalRecords.vue'),
      },
      {
        path: 'create',
        name: 'CreatePetMedicalRecord',
        meta: {requiresAuth: true},
        children: [
          {
            path: '',
            name: 'AddPetMedicalRecord',
            meta: {requiresAuth: true},
            component: () => import('@/features/medical-records/views/MedicalRecord.vue'),
          },
        ],
      },
      {
        path: ':medicalRecordID',
        name: 'PetMedicalRecordDetails',
        meta: {requiresAuth: true},
        component: () => import('@/features/medical-records/views/MedicalRecord.vue'),
      },
    ],
  },
  {
    path: 'vaccines',
    name: 'PetVaccines',
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'ListPetVaccines',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/vaccines/VaccinationRecords.vue'),
      },
      {
        path: 'create',
        name: 'CreatePetVaccine',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/vaccines/VaccinationRecord.vue'),
      },
      {
        path: ':vaccineID',
        name: 'PetVaccineDetails',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/vaccines/VaccinationRecord.vue'),
      },
    ],
  },
  {
    path: 'prescriptions',
    name: 'Prescriptions',
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'ListPetPrescriptions',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/prescriptions/Prescriptions.vue'),
      },
      {
        path: 'create',
        name: 'CreatePrescription',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/prescriptions/Prescription.vue'),
      },
      {
        path: ':prescriptionID',
        name: 'PetPrescriptionDetails',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/prescriptions/Prescription.vue'),
      },
    ],
  },
  {
    path: 'constants',
    name: 'PetConstants',
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'ListPetConstants',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/registries/Registries.vue'),
      },
      {
        path: 'create',
        name: 'CreatePetConstant',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/registries/Registry.vue'),
      },
      {
        path: ':constantID',
        name: 'PetConstantDetails',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/registries/Registry.vue'),
      },
    ],
  },
  {
    path: 'heats',
    name: 'PetHeats',
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'ListPetHeats',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/heats/Heats.vue'),
      },
      {
        path: 'create',
        name: 'CreatePetHeat',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/heats/Heat.vue'),
      },
      {
        path: ':heatID',
        name: 'PetHeatDetails',
        meta: {requiresAuth: true},
        component: () => import('@/features/pets/views/heats/Heat.vue'),
      },
    ],
  },
  {
    path: 'appointments',
    name: 'PetAppointment',
    meta: {requiresAuth: true},
    component: () => import('@/features/appointments/views/Appointment.vue'),
  },
];

export const ownerRoutes: RouteRecordRaw = {
  path: 'owners',
  name: 'Owners',
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      name: 'AddOwner',
      meta: {requiresAuth: true},
      component: () => import('@/features/owners/views/NewOwner.vue'),
    },
    {
      path: ':ownerID',
      name: 'Owner',
      meta: {requiresAuth: true},
      component: () => import('@/layouts/OwnerLayout.vue'),
      children: [
        {
          path: '',
          name: 'OwnerDashboard',
          meta: {requiresAuth: true},
          component: () => import('@/features/owners/views/OwnerDashboard.vue'),
        },
        {
          path: 'info',
          name: 'OwnerDetails',
          meta: {requiresAuth: true},
          component: () => import('@/features/owners/views/OwnerDetails.vue'),
        },
        {
          path: 'credential',
          name: 'OwnerCredential',
          meta: {requiresAuth: true},
          component: () => import('@/features/owners/views/Credential.vue'),
        },
        {
          path: 'appointments',
          name: 'OwnerAppointment',
          meta: {requiresAuth: true},
          component: () => import('@/features/appointments/views/Appointment.vue'),
        },
        {
          path: 'pets',
          name: 'OwnerPets',
          meta: {requiresAuth: true},
          children: [
            {
              path: '',
              name: 'PetsDashboard',
              meta: {requiresAuth: true},
              component: () => import('@/features/pets/views/Dashboard.vue'),
            },
            {
              path: ':petID',
              name: 'Pet',
              meta: {requiresAuth: true},
              component: () => import('@/layouts/PetLayout.vue'),
              children: petChildren,
            },
          ],
        },
        {
          path: 'pets/new',
          name: 'NewPet',
          meta: {requiresAuth: true},
          component: () => import('@/features/pets/views/NewPet.vue'),
        },
        {
          path: 'secondary-owners',
          name: 'SecondaryOwners',
          meta: {requiresAuth: true},
          children: [
            {
              path: '',
              name: 'SecondaryOwnersDashboard',
              meta: {requiresAuth: true},
              component: () => import('@/features/owners/views/secondary/ListOwners.vue'),
            },
            {
              path: ':secondaryOwnerID',
              name: 'SecondaryOwnerDetails',
              meta: {requiresAuth: true},
              component: () => import('@/features/owners/views/secondary/Details.vue'),
            },
            {
              path: 'create',
              name: 'CreateSecondaryOwner',
              meta: {requiresAuth: true},
              component: () => import('@/features/owners/views/secondary/Details.vue'),
            },
          ],
        },
      ],
    },
    {
      path: 'search',
      name: 'SearchOwners',
      meta: {requiresAuth: true},
      component: () => import('@/features/search/views/Searcher.vue'),
    },
    {
      path: 'appointments',
      name: 'Appointments',
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'Appointment',
          meta: {requiresAuth: true},
          component: () => import('@/features/appointments/views/Appointment.vue'),
        },
      ],
    },
  ],
};
